/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ArticleHashModel,
  AuthorsItemModel,
  EpisodeAccessModel,
  EpisodeModel,
  EpisodeSummaryModel,
  GetSeriesBySeriesId404Response,
  LikedEpisode,
  SearchResultModel,
  SeriesAccessModel,
  SeriesModel,
  SeriesSummaryModel,
  StoreItemVolumeDetailModel,
  StoreItemVolumeModel,
} from '../models/index';
import {
    ArticleHashModelFromJSON,
    ArticleHashModelToJSON,
    AuthorsItemModelFromJSON,
    AuthorsItemModelToJSON,
    EpisodeAccessModelFromJSON,
    EpisodeAccessModelToJSON,
    EpisodeModelFromJSON,
    EpisodeModelToJSON,
    EpisodeSummaryModelFromJSON,
    EpisodeSummaryModelToJSON,
    GetSeriesBySeriesId404ResponseFromJSON,
    GetSeriesBySeriesId404ResponseToJSON,
    LikedEpisodeFromJSON,
    LikedEpisodeToJSON,
    SearchResultModelFromJSON,
    SearchResultModelToJSON,
    SeriesAccessModelFromJSON,
    SeriesAccessModelToJSON,
    SeriesModelFromJSON,
    SeriesModelToJSON,
    SeriesSummaryModelFromJSON,
    SeriesSummaryModelToJSON,
    StoreItemVolumeDetailModelFromJSON,
    StoreItemVolumeDetailModelToJSON,
    StoreItemVolumeModelFromJSON,
    StoreItemVolumeModelToJSON,
} from '../models/index';

export interface GetArticleHashKeyRequest {
    viewerId: string;
}

export interface GetAuthorSeriesItemsRequest {
    authorId: string;
    page?: number;
    size?: number;
}

export interface GetEpisodeByIdRequest {
    articleHash: string;
    xComiciUserToken?: string;
}

export interface GetEpisodeByViewerIdRequest {
    viewerId: string;
}

export interface GetEpisodeLikesRequest {
    articleHash: string;
    xComiciUserToken?: string;
}

export interface GetSeriesRequest {
    page?: number;
    size?: number;
    genre?: number;
    status?: GetSeriesStatusEnum;
    sort?: GetSeriesSortEnum;
    category?: GetSeriesCategoryEnum;
    daysOfWeek?: GetSeriesDaysOfWeekEnum;
}

export interface GetSeriesAccessByIdRequest {
    seriesHash: string;
    episodeFrom?: number;
    episodeTo?: number;
    xComiciUserToken?: string;
}

export interface GetSeriesBySeriesIdRequest {
    seriesHash: string;
    xComiciUserToken?: string;
    episodeFrom?: number;
    episodeTo?: number;
}

export interface GetSeriesRecommendRequest {
    targetSeriesId?: string;
    viewedSeriesIds?: Array<string>;
}

export interface GetStoreItemByStoreItemVolumeIdRequest {
    storeItemVolumeId: string;
    xComiciUserToken?: string;
}

export interface GetStoreItemsRequest {
    xComiciUserToken?: string;
    page?: number;
    size?: number;
    seriesId?: string;
}

export interface SearchRequest {
    q?: string;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class ContentsApi extends runtime.BaseAPI {

    /**
     * ビューワーIDを利用してアーティクルのハッシュキーを取得します
     * アーティクルのハッシュキーを取得する
     */
    async getArticleHashKeyRaw(requestParameters: GetArticleHashKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ArticleHashModel>> {
        if (requestParameters.viewerId === null || requestParameters.viewerId === undefined) {
            throw new runtime.RequiredError('viewerId','Required parameter requestParameters.viewerId was null or undefined when calling getArticleHashKey.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/articleHash/{viewer_id}`.replace(`{${"viewer_id"}}`, encodeURIComponent(String(requestParameters.viewerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticleHashModelFromJSON(jsonValue));
    }

    /**
     * ビューワーIDを利用してアーティクルのハッシュキーを取得します
     * アーティクルのハッシュキーを取得する
     */
    async getArticleHashKey(requestParameters: GetArticleHashKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ArticleHashModel> {
        const response = await this.getArticleHashKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 著者によりの作品を取得します
     * 著者作品リスト取得
     */
    async getAuthorSeriesItemsRaw(requestParameters: GetAuthorSeriesItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeriesSummaryModel>>> {
        if (requestParameters.authorId === null || requestParameters.authorId === undefined) {
            throw new runtime.RequiredError('authorId','Required parameter requestParameters.authorId was null or undefined when calling getAuthorSeriesItems.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/authors/{author_id}`.replace(`{${"author_id"}}`, encodeURIComponent(String(requestParameters.authorId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SeriesSummaryModelFromJSON));
    }

    /**
     * 著者によりの作品を取得します
     * 著者作品リスト取得
     */
    async getAuthorSeriesItems(requestParameters: GetAuthorSeriesItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeriesSummaryModel>> {
        const response = await this.getAuthorSeriesItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 対象サイトで現在公開しているエピソードに紐づく著者のリストを名前の昇順で返却します。 ソートはデータベースからのデータ取得時に行われ、MySQLの `utf8mb4_bin` 指定の順序となります。
     * 著者リスト取得
     */
    async getAuthorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AuthorsItemModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/authors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AuthorsItemModelFromJSON));
    }

    /**
     * 対象サイトで現在公開しているエピソードに紐づく著者のリストを名前の昇順で返却します。 ソートはデータベースからのデータ取得時に行われ、MySQLの `utf8mb4_bin` 指定の順序となります。
     * 著者リスト取得
     */
    async getAuthors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AuthorsItemModel>> {
        const response = await this.getAuthorsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 指定したエピソードのコンテンツを取得します。無料コンテンツ以外を取得するには、ユーザーの認証情報が必要です。
     * エピソード1件取得
     */
    async getEpisodeByIdRaw(requestParameters: GetEpisodeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EpisodeModel>> {
        if (requestParameters.articleHash === null || requestParameters.articleHash === undefined) {
            throw new runtime.RequiredError('articleHash','Required parameter requestParameters.articleHash was null or undefined when calling getEpisodeById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/{article_hash}`.replace(`{${"article_hash"}}`, encodeURIComponent(String(requestParameters.articleHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EpisodeModelFromJSON(jsonValue));
    }

    /**
     * 指定したエピソードのコンテンツを取得します。無料コンテンツ以外を取得するには、ユーザーの認証情報が必要です。
     * エピソード1件取得
     */
    async getEpisodeById(requestParameters: GetEpisodeByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EpisodeModel> {
        const response = await this.getEpisodeByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * コミチビューワー専用エンドポイント
     * エピソード1件取得 (ビューアID指定)
     */
    async getEpisodeByViewerIdRaw(requestParameters: GetEpisodeByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EpisodeSummaryModel>> {
        if (requestParameters.viewerId === null || requestParameters.viewerId === undefined) {
            throw new runtime.RequiredError('viewerId','Required parameter requestParameters.viewerId was null or undefined when calling getEpisodeByViewerId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/viewer/{viewer_id}`.replace(`{${"viewer_id"}}`, encodeURIComponent(String(requestParameters.viewerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EpisodeSummaryModelFromJSON(jsonValue));
    }

    /**
     * コミチビューワー専用エンドポイント
     * エピソード1件取得 (ビューアID指定)
     */
    async getEpisodeByViewerId(requestParameters: GetEpisodeByViewerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EpisodeSummaryModel> {
        const response = await this.getEpisodeByViewerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定したユーザーが、このエピソードに対して贈った\"いいね\"の数を取得します。
     * エピソードいいね数取得
     */
    async getEpisodeLikesRaw(requestParameters: GetEpisodeLikesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LikedEpisode>> {
        if (requestParameters.articleHash === null || requestParameters.articleHash === undefined) {
            throw new runtime.RequiredError('articleHash','Required parameter requestParameters.articleHash was null or undefined when calling getEpisodeLikes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/articles/{article_hash}/likeCount`.replace(`{${"article_hash"}}`, encodeURIComponent(String(requestParameters.articleHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LikedEpisodeFromJSON(jsonValue));
    }

    /**
     * 指定したユーザーが、このエピソードに対して贈った\"いいね\"の数を取得します。
     * エピソードいいね数取得
     */
    async getEpisodeLikes(requestParameters: GetEpisodeLikesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LikedEpisode> {
        const response = await this.getEpisodeLikesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されている作品の一覧を取得します。  取得される一覧は作品の概要情報のみを含みます。エピソードを含む情報は、取得したい作品の作品IDを元に取得します。
     * シリーズリスト取得
     */
    async getSeriesRaw(requestParameters: GetSeriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeriesSummaryModel>>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.genre !== undefined) {
            queryParameters['genre'] = requestParameters.genre;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.category !== undefined) {
            queryParameters['category'] = requestParameters.category;
        }

        if (requestParameters.daysOfWeek !== undefined) {
            queryParameters['daysOfWeek'] = requestParameters.daysOfWeek;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SeriesSummaryModelFromJSON));
    }

    /**
     * 配信されている作品の一覧を取得します。  取得される一覧は作品の概要情報のみを含みます。エピソードを含む情報は、取得したい作品の作品IDを元に取得します。
     * シリーズリスト取得
     */
    async getSeries(requestParameters: GetSeriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeriesSummaryModel>> {
        const response = await this.getSeriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 作品の閲覧権限を取得します。  認証されたユーザーのアクセストークンが渡された場合は、そのユーザー固有の閲覧権限を返します。
     * 作品エピソード閲覧権限取得
     */
    async getSeriesAccessByIdRaw(requestParameters: GetSeriesAccessByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesAccessModel>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling getSeriesAccessById.');
        }

        const queryParameters: any = {};

        if (requestParameters.episodeFrom !== undefined) {
            queryParameters['episodeFrom'] = requestParameters.episodeFrom;
        }

        if (requestParameters.episodeTo !== undefined) {
            queryParameters['episodeTo'] = requestParameters.episodeTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/{series_hash}/permissions`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeriesAccessModelFromJSON(jsonValue));
    }

    /**
     * 作品の閲覧権限を取得します。  認証されたユーザーのアクセストークンが渡された場合は、そのユーザー固有の閲覧権限を返します。
     * 作品エピソード閲覧権限取得
     */
    async getSeriesAccessById(requestParameters: GetSeriesAccessByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesAccessModel> {
        const response = await this.getSeriesAccessByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 作品IDをもとに、特定の作品情報を取得します。
     * シリーズ1件取得
     */
    async getSeriesBySeriesIdRaw(requestParameters: GetSeriesBySeriesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeriesModel>> {
        if (requestParameters.seriesHash === null || requestParameters.seriesHash === undefined) {
            throw new runtime.RequiredError('seriesHash','Required parameter requestParameters.seriesHash was null or undefined when calling getSeriesBySeriesId.');
        }

        const queryParameters: any = {};

        if (requestParameters.episodeFrom !== undefined) {
            queryParameters['episodeFrom'] = requestParameters.episodeFrom;
        }

        if (requestParameters.episodeTo !== undefined) {
            queryParameters['episodeTo'] = requestParameters.episodeTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/{series_hash}`.replace(`{${"series_hash"}}`, encodeURIComponent(String(requestParameters.seriesHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeriesModelFromJSON(jsonValue));
    }

    /**
     * 作品IDをもとに、特定の作品情報を取得します。
     * シリーズ1件取得
     */
    async getSeriesBySeriesId(requestParameters: GetSeriesBySeriesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeriesModel> {
        const response = await this.getSeriesBySeriesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 作品IDを渡すとオススメの作品情報4作品分が取得できる
     * 作品レコメンド取得
     */
    async getSeriesRecommendRaw(requestParameters: GetSeriesRecommendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeriesSummaryModel>>> {
        const queryParameters: any = {};

        if (requestParameters.targetSeriesId !== undefined) {
            queryParameters['targetSeriesId'] = requestParameters.targetSeriesId;
        }

        if (requestParameters.viewedSeriesIds) {
            queryParameters['viewedSeriesIds'] = requestParameters.viewedSeriesIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/series/recommends`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SeriesSummaryModelFromJSON));
    }

    /**
     * 作品IDを渡すとオススメの作品情報4作品分が取得できる
     * 作品レコメンド取得
     */
    async getSeriesRecommend(requestParameters: GetSeriesRecommendRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeriesSummaryModel>> {
        const response = await this.getSeriesRecommendRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 単行本IDをもとに、特定の単行本情報を取得します。
     * 単行本1件取得
     */
    async getStoreItemByStoreItemVolumeIdRaw(requestParameters: GetStoreItemByStoreItemVolumeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreItemVolumeModel>> {
        if (requestParameters.storeItemVolumeId === null || requestParameters.storeItemVolumeId === undefined) {
            throw new runtime.RequiredError('storeItemVolumeId','Required parameter requestParameters.storeItemVolumeId was null or undefined when calling getStoreItemByStoreItemVolumeId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/storeItems/{store_item_volume_id}`.replace(`{${"store_item_volume_id"}}`, encodeURIComponent(String(requestParameters.storeItemVolumeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreItemVolumeModelFromJSON(jsonValue));
    }

    /**
     * 単行本IDをもとに、特定の単行本情報を取得します。
     * 単行本1件取得
     */
    async getStoreItemByStoreItemVolumeId(requestParameters: GetStoreItemByStoreItemVolumeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreItemVolumeModel> {
        const response = await this.getStoreItemByStoreItemVolumeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信されている単行本の一覧を取得します 取得される一覧は単行本の概要情報のみを含みます。 今月の新刊および来月以降の新刊は1ページ目を取得した場合のみ返却します
     * 単行本リスト取得
     */
    async getStoreItemsRaw(requestParameters: GetStoreItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StoreItemVolumeDetailModel>>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.seriesId !== undefined) {
            queryParameters['seriesId'] = requestParameters.seriesId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserToken !== undefined && requestParameters.xComiciUserToken !== null) {
            headerParameters['X-Comici-User-Token'] = String(requestParameters.xComiciUserToken);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/storeItems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StoreItemVolumeDetailModelFromJSON));
    }

    /**
     * 配信されている単行本の一覧を取得します 取得される一覧は単行本の概要情報のみを含みます。 今月の新刊および来月以降の新刊は1ページ目を取得した場合のみ返却します
     * 単行本リスト取得
     */
    async getStoreItems(requestParameters: GetStoreItemsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StoreItemVolumeDetailModel>> {
        const response = await this.getStoreItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 与えられた文字列を元に作品を検索します。
     * 検索結果取得
     */
    async searchRaw(requestParameters: SearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResultModel>> {
        const queryParameters: any = {};

        if (requestParameters.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchResultModelFromJSON(jsonValue));
    }

    /**
     * 与えられた文字列を元に作品を検索します。
     * 検索結果取得
     */
    async search(requestParameters: SearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResultModel> {
        const response = await this.searchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSeriesStatusEnum = {
    Continue: 'continue',
    Complete: 'complete',
    OneShot: 'oneShot'
} as const;
export type GetSeriesStatusEnum = typeof GetSeriesStatusEnum[keyof typeof GetSeriesStatusEnum];
/**
 * @export
 */
export const GetSeriesSortEnum = {
    PublishDate: 'publishDate',
    UpdatedOn: 'updatedOn',
    NumFavorite: 'numFavorite'
} as const;
export type GetSeriesSortEnum = typeof GetSeriesSortEnum[keyof typeof GetSeriesSortEnum];
/**
 * @export
 */
export const GetSeriesCategoryEnum = {
    Manga: 'manga',
    Gravure: 'gravure',
    Column: 'column'
} as const;
export type GetSeriesCategoryEnum = typeof GetSeriesCategoryEnum[keyof typeof GetSeriesCategoryEnum];
/**
 * @export
 */
export const GetSeriesDaysOfWeekEnum = {
    Mon: 'mon',
    Tue: 'tue',
    Wed: 'wed',
    Thu: 'thu',
    Fri: 'fri',
    Sat: 'sat',
    Sun: 'sun',
    Other: 'other'
} as const;
export type GetSeriesDaysOfWeekEnum = typeof GetSeriesDaysOfWeekEnum[keyof typeof GetSeriesDaysOfWeekEnum];
